// Utility para logs condicionales - solo en desarrollo
const isDevelopment = process.env.NODE_ENV === 'development';


export const logger = {
  log: isDevelopment ? console.log : () => {},
  warn: isDevelopment ? console.warn : () => {},
  error: console.error, // Errores siempre se muestran
  info: isDevelopment ? console.info : () => {}
};
